import { Fragment, useState, useEffect } from "react";
import styled from "@emotion/styled";

import { Button, ButtonGroup } from "@mui/material";

import { useFormikContext } from "formik";

import { useFormData } from "../../../contexts/FormData";

import Dialog from "../../../utils/utilities/Dialog";

import useInvoiceActionStore from "../../../store/invoice_actions";

import EditRepairTicket from "../../Repair_Tickets/EditRepairTicket";

import EditWigOrder from "../../WigOrders/EditWigOrder";

import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import PostAddRoundedIcon from '@mui/icons-material/PostAddRounded';
import CalculateRoundedIcon from '@mui/icons-material/CalculateRounded';

import useIsMobile from "../../../hooks/useIsMobile";

import AdjustmentForm from "./CustomAdjustment";

const SaveConfirmation = styled.div`
  padding: 1.6rem;
`

const CustomAdjustment = ({ open, close, ...props }) => {
 
  return (
    <Dialog
      title="Custom Item"
      key="custom-item"
      size="lg"
      forceOpen={open}
      forceClose={() => close(false)}
      useForm={true}
    >
      <AdjustmentForm  />
    </Dialog>
  )
};


const ActionBar = () => {

  const { isMobile } = useIsMobile();

  const { values, submitForm } = useFormikContext() || {};
  
  const { formValues } = useFormData() || {};

  let disabled = !values?.customer_id

  const [openSaveDialog, setOpenSaveDialog] = useState(false);
  // const [action, setAction] = useState(null);

  const [additionalDialog, setAdditionalDialog] = useState(null);

  const setPendingIADialog = useInvoiceActionStore((state) => state.setPendingIADialog);
  const pendingIADialog = useInvoiceActionStore((state) => state.pendingIADialog);
  const setInvoiceData = useInvoiceActionStore((state) => state.setInvoiceData);
  const action = useInvoiceActionStore((state) => state.action);
  const setAction = useInvoiceActionStore((state) => state.setAction);

  let is_edit = !!values?.invoice_id;
  let id = `${values?.customer_id?.toString()}-${action}`

  const [openActionDialog, setOpenActionDialog] = useState(false);

  let invoice_data = {
    invoice_id: values?.invoice_id,
    customer: {
      customer_id: values?.customer_id,
      full_name: formValues?.client_name || values?.client_name
    },
    customer_id: values?.customer_id,
    customer_name: formValues?.client_name || values?.client_name,
    appointment_id: values?.appointment_id,
    order_type: "custom",
    stylist_rep: values?.stylist_id
  }

  // let id = `${values?.customer_id?.toString()}-${action}`

  // const saveInvoice = () => {
  //   setPendingIADialog(id);
  //   submitForm();
  //   setOpenSaveDialog(false)
  // }
  const saveInvoice = (e, action) => {
    setAction(action);
    setPendingIADialog(`${values?.customer_id?.toString()}-${action}`);
    submitForm();
    // setOpenSaveDialog(false)
  }

  const handleSelectAction = (e, action) => {
    setAction(action);
    setOpenSaveDialog(true);
  }

  useEffect(() => {
    console.log({is_edit, pendingIADialog, id});
    if (is_edit && pendingIADialog === id) {
      setOpenActionDialog(true);
      setInvoiceData(invoice_data);
    }
  }, [is_edit, pendingIADialog])

  const handleClose = () => {
    setAction(null);
    setOpenActionDialog(false);
  }

  let dialogTitle = null;

  switch (action) {
    case "repairs":
      dialogTitle = "Add Repairs";
      break;
    case "custom":
      dialogTitle = "Add Custom Wig Order";
      break;
    case "charges":
      dialogTitle = "Add General Item";
      break;
    default:
      break;
  }

  return (
    <Fragment>

      <Dialog
        title="Save Invoice"
        saveText="Save Invoice"
        forceOpen={openSaveDialog}
        forceClose={() => setOpenSaveDialog(false)}
        saveFunc={saveInvoice}
      >
        <SaveConfirmation>
          To Proceed you must first save the invoice. Hit save to confirm.
        </SaveConfirmation>
      </Dialog>


      <Dialog
        title={dialogTitle}
        forceOpen={openActionDialog}
        forceClose={handleClose}
        fullScreen
        useForm={true}
      >
       {action === "repairs" && <EditRepairTicket dialog={true} />}
       {action === "custom" && <EditWigOrder dialog={true} appt_info={invoice_data} ignore_id={true} />}
       {action === "charges" && "Charges"}
      </Dialog>

      <CustomAdjustment open={additionalDialog} close={setAdditionalDialog} />


    <ButtonGroup
      variant="outlined"
      color="basic"
      disableElevation
      orientation={isMobile ? "vertical" : "horizontal"}
      size="large"
      fullWidth
      sx={{mt: "0"}}
      disabled={disabled}
    >
      <Button 
      onClick={(e) => saveInvoice(e, "repairs")}
      startIcon={<ContentCutRoundedIcon />}
      >Add Repairs</Button>
      <Button 
      onClick={(e) => saveInvoice(e, "custom")}
      startIcon={<ReceiptLongRoundedIcon />}
      >Add Custom Wig Order</Button>
      <Button 
      onClick={(e) => setAdditionalDialog(true)}
      startIcon={<PostAddRoundedIcon />}
      >Add General Item</Button>
    </ButtonGroup>
    </Fragment>
  );

};

export default ActionBar;